import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import IStoreState from 'store/IStoreState';
import {
  getAuthorizedUser,
  startB2CAuth,
} from 'modules/auth/stateManagement/thunks';
import { loginUserSuccess } from 'modules/auth/stateManagement/actionsCreator';
import { IAuthorizationProviderDispatchProps } from 'modules/auth/components/AuthProvider';
import useNotifier from 'modules/popupNotification/hooks/useNotifier';
import {
  NavigationPath,
  Ic2fxComponentType,
} from 'models/enum';
import { checkAppIsRunningInTeams } from 'utilities/teamsRuntime';
import AppToolbar from './shared/modules/appToolbar/appToolbar';
import {
  IGetSystemMaintenanceState,
  IRBACState,
} from 'shared/stateManagement/state';
//import { getSystemMaintenance } from 'shared/stateManagement/thunks';
import Ic2fxComponentWrapper from 'shared/components/ic2fxComponentWrapper';
import NotificationsHandler from 'shared/components/NotificationsHandler';
import { useNavigate } from 'react-router-dom';
import {
  axiosGetKfasConfig,
  getHiringManagerDetails,
} from 'modules/hiring/stateManagement/api';
import { useConfig } from 'utilities/hooks/useConfig';
import * as microsoftTeams from '@microsoft/teams-js';

export interface IEEApp extends IAuthorizationProviderDispatchProps {
  token: string;
  roles: string[];
  getAuthorizedEmployee?: () => void;
 // getSystemMaintenance: () => void;
  //systemMaintenance: IGetSystemMaintenanceState;
  rbacConfig: IRBACState;
  ssoToken: string;
  isFetchingEmployeeData: boolean;
  employeeId: number | undefined;
}

const EEApp = ({
  token,
  roles,
  getAuthorizedEmployee,
  saveSSOToken,
 // getSystemMaintenance: getSystemMaintenanceRunning,
  //systemMaintenance,
  ssoToken,
  rbacConfig,
  isFetchingEmployeeData,
  employeeId,
}: IEEApp) => {
  const [isAppReady, setIsAppReady] = useState<boolean>(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const hasInitialized = useRef(false);
  const navigate = useNavigate();

  const { config, setConfig } = useConfig();
  useNotifier();

  async function fetchConfig() {
    if (!config) {
      const { nimbleOrgId } = await getHiringManagerDetails();
      await axiosGetKfasConfig(nimbleOrgId).then((x) => {
        setConfig({
          isKfasEnabled: x.isKfasEnabled,
          kfasClientId: x.kfasClientId,
        });
      });
    }
  }

  useEffect(() => {
   // getSystemMaintenanceRunning();
    fetchConfig();
  }, []);

  useEffect(() => {
    /* istanbul ignore else */
    if (token) {
      saveSSOToken(token, roles);
      // Call gets triggered for Employee Profile
      getAuthorizedEmployee?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, roles]);

  /* fix for auth issue for init login  */
  // useEffect(() => {
  //   if (
  //     ssoToken &&
  //     !checkAppIsRunningInTeams()
  //   ) {
  //     window.location.reload();
  //   }
  // }, [ssoToken]);

  // Teams deep link support with new Microsoft Teams JS SDK
  useEffect(() => {
    if (!checkAppIsRunningInTeams()) {
      setIsFirstLoad(false);
      return;
    }

    const alreadyLoaded = sessionStorage.getItem('hasLoaded');
    const params = new URLSearchParams(window.location.search);
    const ignoreContext = params.get('ignoreContext') === 'true';

    if (isFirstLoad && !hasInitialized.current) {
      hasInitialized.current = true;
      
      const initializeTeams = async () => {
        try {
          // Initialize Teams SDK v2 (async)
          await microsoftTeams.app.initialize();
          
          // Get context with error handling
          try {
            const context = await microsoftTeams.app.getContext();
            // Check for subEntityId (v1 compatibility) or subPageId (v2)
            const subEntityId = (context as any)?.subEntityId || 
                               context?.page?.subPageId;
            
            if (subEntityId) {
              const decodedPath = decodeURIComponent(subEntityId);
              navigate(`/${decodedPath}`);
            }
          } catch (contextError: any) {
            // Handle 404 or other errors gracefully
            console.warn('Could not get Teams context (this may be expected in some contexts):', contextError?.message || contextError);
          }
          
          sessionStorage.setItem('hasLoaded', 'true');
          setIsFirstLoad(false);
        } catch (initError: any) {
          console.warn('Teams initialization failed:', initError?.message || initError);
          sessionStorage.setItem('hasLoaded', 'true');
          setIsFirstLoad(false);
        }
      };
      
      initializeTeams();
    } else {
      setIsFirstLoad(false);
    }
  }, [navigate, isFirstLoad]);

  useEffect(() => {
    if (
      (ssoToken !== '')
    ) {
      setIsAppReady(true);
    }
  }, [
    ssoToken,
  ]);

  return (
    <>
      {ssoToken ? (
        <>
          {isAppReady &&     (
              <LocalizationProvider dateAdapter={AdapterLuxon}>
                  {window.location.pathname !== NavigationPath.authstart &&
                    window.location.pathname !== NavigationPath.authend && (
                      <AppToolbar />
                    )}
                  {/* @ts-ignore - NotificationsHandler props come from Redux connect */}
                  {/* <NotificationsHandler /> */}

              </LocalizationProvider>
            )}
        </>
      ) : (
        <Ic2fxComponentWrapper componentType={Ic2fxComponentType.loader} />
      )}
    </>
  );
};

const mapStateToProps = (state: IStoreState) => ({
  employeeId: state.employee.employee?.id,
  systemMaintenance: state.systemMaintenance,
  rbacConfig: state.rbac,
  ssoToken: state.auth?.ssoToken,
  isFetchingEmployeeData: state.employee.isFetchingData,
});

const mapDispatchToProps = {
 // getAuthorizedEmployee: getAuthorizedUser,
 // startAuthorization: startB2CAuth,
  saveSSOToken: loginUserSuccess,
  //getSystemMaintenance,
};

export default connect(mapStateToProps, mapDispatchToProps)(EEApp);
